import { isArray, isNumber, isObject, isString } from '../utils/typeUtils';

export type Crawler = {
  id: number;
  name: string;
  imageName: string;
  apiKeyTemplateId: number;
};

/**
 * クローラー情報 型ガード
 */
export const isCrawler = (arg: unknown): arg is Crawler => {
  const a = arg as Crawler;

  return (
    isObject(a) && isNumber(a.id) && isString(a.name) && isString(a.imageName)
  );
};

export const isCrawlers = (arg: unknown): arg is Crawler[] =>
  isArray(arg, isCrawler);
